<template>
  <div class="list" name="info">
    <el-row style="margin-top:-10px">
      <el-form :inline="true" class="demo-inline-form" :model="search_qrcode">
        <el-card class="searchCard" shadow="never">
          <el-form-item label="交易日期">
            <date-range-picker v-model="comeTime" :value="comeTime" ref="comeTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input
              style="width:260px;"
              v-model="search_qrcode.merchantId"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input
              style="width:260px;"
              v-model="search_qrcode.merchantName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="直属代理商">
            <el-select
              prop="fBelongsAgentId"
              class="inline-input branch-input branch"
              v-model="search_qrcode.agentId"
              placeholder="直属代理商"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                v-for="item in agents_search_list"
                :key="item.fAgentId"
                :label="item.fAgentId"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易类型">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.busType"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="微信" value="2"></el-option>
              <el-option label="支付宝" value="3"></el-option>
              <el-option label="pos刷卡" value="1"></el-option>
              <el-option label="银联扫码" value="6"></el-option>
              <el-option label="快捷支付" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算类型">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.t0Flag"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="D1" value="0"></el-option>
              <el-option label="D0" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              plain
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="qrcodeLoading"
              :disabled="disabledExport"
              :label="'查询' + (disabledExport? (times+'s') : '')"></auth-button>
            <auth-button
              opt="export"
              plain
              download="商户交易统计.csv"
              icon="el-icon-download"
              :disabled="disabledExport"
              @click.native="buttomExport"
              :label="'导出' + (disabledExport? (times+'s') : '')"
              :loading="exportLoading"></auth-button>
          </el-form-item>
          <!-- 合计 -->
          <el-col>
            <el-form :inline="true">
              <el-form-item label="合计" style="5%; font-weight: bold;"></el-form-item>
              <el-form-item label="交易金额：">{{ totalAmountCount.totalAmount }}</el-form-item>
              <el-form-item label="交易笔数：">{{ totalAmountCount.totalTxCount }}</el-form-item>
            </el-form>
          </el-col>
          <div class="search-tips">说明：导出最大支持100000条数据</div>
        </el-card>
        <el-card class="tableCard" shadow="never">
          <!-- 列表模块 -->
          <el-table
            stripe
            style="width:100%"
            align="center"
            v-loading="qrcodeLoading"
            :data="qrcode_list"
            :header-cell-style="{background:'#FAFAFA'}"
            @sort-change="tableSortChange"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="fTimeStr"
              label="交易日期"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="fMerchantId"
              label="商户编号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fMerchantName"
              label="商户名称"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fAgentId"
              label="直属代理商"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fBusTypeStr"
              label="交易类型"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fTradeCardType"
              label="刷卡类型"
              align="center">
              <template slot-scope="scope">
                <span>{{getTradeCardType(scope.row.fTradeCardType)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="fT0FlagStr"
              label="结算类型"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fAmountStr"
              label="交易金额（元）"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fCount"
              label="交易笔数"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fCommissionStr"
              label="商户结算费率"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fCommissionFixedStr"
              label="单笔手续费（元）"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fCommissionFeeStr"
              label="商户手续费总额（元）"
              align="center">
            </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </el-row>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { parseTime } from '@/utils/formatTime'

import { directSubAgentInfo, mtList, exportMtList } from '@/api/transaction'

export default {
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().setDate(1))
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      comeTime: [todayZeroStr, todayStr],
      qrcode_list: [],
      group_list: [],
      bank_list: [],
      pro_list: [],
      city_list: [],
      area_list: [],
      bank_pro_list: [],
      bank_city_list: [],
      branch_list: [],
      effect_privilege_level_list: [],
      areas: [],
      citys: [],
      data: [],
      pos: [],
      scan: [],
      dataParam: {},
      domain: 'https://pos.yeahka.com/',
      picDomain: 'https://pic.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      qrCodeNum: '',
      staffsNum: '',
      roleName: '',
      qrcodeLoading: false,
      dialogVisible: false,
      dialogDistribute: false,
      dialogBinding: false,
      dialogSingleBinding: false,
      showCostCommission: false,
      addLoading: false,
      authLoading: false,
      picLoading: false,
      zfztDisabledInput: true,
      gzztDisabledInput: true,
      groupIdDisabledInput: false,
      disabledInput: false,
      editLoading: false,
      holderDisabledInput: false,
      headShopMerchantIdInput: false,
      publicsignalAppidGZItem: true,
      publicsignalAppidItem: true,
      publicsignalAuthorizationDirectoryItem: true,
      dialogDisabled: false,
      settleDialogDisabled: false,
      settleToDisabled: false,
      nopassReason: false,
      editable: false,
      currentAgentId: '',
      totalAmountCount: {
        totalAmount: '--',
        totalTxCount: '--'
      },
      picLoadingArr: [{ idcardFront: false }, { idcardBack: false },
        { bankcardFront: false },
        { businessLicenseC: false },
        { doorPhoto: false },
        { cashierDesk: false },
        { businessInside: false },
        { nonLegSettleAuth: false },
        { nonLegIdcardFront: false },
        { nonLegIdcardBack: false },
        { protocolPage: false },
        { taxRegCert: false },
        { organizationCode: false },
        { leaseContract: false }],
      // 修改界面数据
      other: {
        mccType: '',
        gzzt: '', // 关注主体
        zfzt: '' // 支付主体
      },
      fRate: '',
      userId: '',
      userName: '',
      rule_data: {
        startQrcodeNum: [{
          validator: (rule, value, callback) => {
            if (!(/^LS\d{10}$/.test(value))) {
              callback(new Error('请输入正确的码牌号'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        endQrcodeNum: [{
          validator: (rule, value, callback) => {
            if (!(/^LS\d{10}$/.test(value))) {
              callback(new Error('请输入正确的码牌号'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        distributeAgentId: [
          { required: true, message: '请输入下级代理/业务员', trigger: 'blur' }
        ],
        fMerchantId: [
          { required: true, message: '请输入商户编号', trigger: 'blur' }
        ]
      },
      // 搜索表单信息
      search_qrcode: {
        startDate: '',
        endDate: '',
        merchantId: '',
        merchantName: '',
        agentId: '',
        agentName: '',
        busType: '',
        t0Flag: '',
        pageNo: '',
        pageSize: '',
        totalCount: '',
        FShopType: '',
        FSettleTo: ''
      },
      licenseChecked: false,
      exportLoading: false,
      pics: {
        idcardFront: '',
        idcardBack: '',
        bankcardFront: '',
        businessLicenseC: '',
        doorPhoto: '',
        cashierDesk: '',
        businessInside: '',
        protocolPage: '',
        nonLegSettleAuth: '',
        nonLegIdcardFront: '',
        nonLegIdcardBack: '',
        taxRegCert: '',
        organizationCode: '',
        leaseContract: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面
        idcardFrontUrl: '',
        idcardBackUrl: '',
        bankcardFrontUrl: '',
        businessLicenseCUrl: '',
        doorPhotoUrl: '',
        cashierDeskUrl: '',
        businessInsideUrl: '',
        protocolPageUrl: '',
        nonLegSettleAuthUrl: '',
        taxRegCertUrl: '',
        organizationCodeUrl: '',
        leaseContractUrl: ''
      },

      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        total: 0,
        pageSize: 20
      },
      pickerOptions: {

      },
      agents_search_list: [],
      agents_search_list_back: [],
      disabledExport: false, // 禁止导出
      interval: '', // 导出限制计时器
      times: 10,
      agentId: '',
      cardTypeList: [
        { value: 1, name: '借记卡' },
        { value: 2, name: '贷记卡' },
        { value: 3, name: '境外卡' }
      ]
    }
  },
  mounted () {
    this.getAgentsList()
    this.getList(true)
  },
  created () {
    const user = JSON.parse(localStorage.getItem('ZZGAgentUser'))
    if (user && user.userEntity && user.userEntity.fAgentId) {
      this.agentId = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity.fAgentId
      const time = localStorage.getItem('EXPORT_TRADE_TIME_' + this.agentId)
      if (time) {
        const now = new Date()
        console.log(now - time)
        // 计算时间是否已经超过10s
        if (now - time > 10 * 1000) {
          localStorage.removeItem('EXPORT_TRADE_TIME_' + this.agentId)
        } else {
          this.disabledExport = true
          this.times = 10 - Math.floor((now - time) / 1000)
          this.countdown()
        }
      }
    }
  },
  methods: {
    dateChange (value) {
      this.comeTime = value
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.qrCodeNum
      // var pageSize = this.qrcode_list.length;
      this.paginations.pageNo = page
      this.search_qrcode.count = totalCount
      this.getList()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      // this.search_qrcode.pageNo = 1;
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      if (this.disabledExport) return
      // 当点击查询时，显示第一页
      this.search_qrcode.pageNo = 1
      // 让页码数回归到1
      this.paginations.pageNo = 1
      this.onSearch()
    },
    getList (isInit) {
      this.search_qrcode.startDate = this.comeTime && this.comeTime[0] ? this.comeTime[0] : ''
      this.search_qrcode.endDate = this.comeTime && this.comeTime[1] ? this.comeTime[1] : ''
      var startDate = this.search_qrcode.startDate
      var endDate = this.search_qrcode.endDate
      if (startDate == null || startDate === '') {
        this.$message({
          showClose: true,
          message: '起始时间不能为空，请检查后重试',
          type: 'error'
        })
        return
      }
      if (endDate == null || endDate === '') {
        this.$message({
          showClose: true,
          message: '结束时间不能为空，请检查后重试',
          type: 'error'
        })
        return
      }
      if (startDate.substring(0, 8) !== endDate.substring(0, 8)) {
        this.$message({
          showClose: true,
          message: '目前仅支持查询一个月内数据，不能跨月查询，请检查后重试',
          type: 'error'
        })
        return
      }
      this.qrcodeLoading = true
      if (!isInit) {
        this.disabledExport = true
        this.countdown()
        localStorage.setItem('EXPORT_TRADE_TIME_' + this.agentId, Date.now())
      }
      this.totalAmountCount.totalAmount = ''
      this.totalAmountCount.totalTxCount = ''
      this.search_qrcode = Object.assign(this.search_qrcode, this.paginations)
      var data = this.formatSearch(this.search_qrcode)
      data = qs.stringify(data)
      mtList(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.qrcodeLoading = false
        } else {
          this.qrcodeLoading = false
          this.paginations.count = data.totalCount
          this.qrcode_list = data.list
          this.qrCodeNum = data.totalCount
          this.totalAmountCount.totalAmount = (data.totalAmount == null || data.totalAmount === '0.00') ? '--' : data.totalAmount
          this.totalAmountCount.totalTxCount = (data.totalTxCount == null || data.totalTxCount === '0') ? '--' : data.totalTxCount

          if (data.agentLevel === '1') {
            this.showCostCommission = true
          }

          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        }
      })
    },
    tableSortChange (val) {
      this.getList()
    },
    buttomExport () {
      if (this.disabledExport) return
      this.search_qrcode.startDate = this.comeTime && this.comeTime[0] ? this.comeTime[0] : ''
      this.search_qrcode.endDate = this.comeTime && this.comeTime[1] ? this.comeTime[1] : ''
      var startDate = this.search_qrcode.startDate
      var endDate = this.search_qrcode.endDate
      if (startDate == null || startDate === '') {
        this.$message({
          showClose: true,
          message: '起始时间不能为空，请检查后重试',
          type: 'error'
        })
        return
      }
      if (endDate == null || endDate === '') {
        this.$message({
          showClose: true,
          message: '结束时间不能为空，请检查后重试',
          type: 'error'
        })
        return
      }
      if (startDate.substring(0, 8) !== endDate.substring(0, 8)) {
        this.$message({
          showClose: true,
          message: '目前不支持跨月导出，请检查后重试',
          type: 'error'
        })
        return
      }
      // 当点击查询时，显示第一页
      this.search_qrcode.pageNo = 1
      this.export()
    },
    export () {
      this.exportLoading = true
      this.exportList()
    },
    exportList () {
      const data = qs.stringify(Object.assign({}, this.search_qrcode, {
        moduleCode: 1,
        moduleName: '交易',
        menuName: '交易统计'
      }))
      exportMtList(data).then(response => {
        this.exportLoading = false
        this.disabledExport = true
        // 10s内不允许导出
        this.countdown()
        localStorage.setItem('EXPORT_TRADE_TIME_' + this.agentId, Date.now())
        if (response.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 直属代理商自定义筛选方法
       */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.agents_search_list = this.agents_search_list_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.agents_search_list = this.agents_search_list_back
      }
    },
    /**
       * 获取代理商列表方法
       */
    getAgentsList () {
      // 设一个超大的pageSize取所有数据
      directSubAgentInfo('pageSize=655350').then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          console.log('输出直属代理商')
          console.log(localStorage)
          const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
          const agentList = [{
            fAgentId: userInfo.fAgentId,
            fTitle: userInfo.fTitle
          }]
          this.agents_search_list = agentList.concat(data.list)
          this.agents_search_list_back = [...this.agents_search_list]
        }
      })
    },
    countdown () {
      this.interval = setInterval(() => {
        if (this.times > 1) {
          this.times = this.times - 1
        } else {
          this.times = 10
          clearInterval(this.interval)
          this.disabledExport = false
        }
      }, 1000)
    },
    getTradeCardType (cardType) {
      const list = this.cardTypeList.filter(item => {
        return item.value === cardType
      })
      if (!list.length) {
        return '-'
      } else {
        return list[0].name
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss">
    .demo-inline-form {
      margin-top: 10px;
    }
    .demo-form-inline {
        display: inline-block;
        float: right;
    }

    .btm-action {
        margin: 20px 0;
        text-align: center;
    }

    .pagination {
        display: inline-block;
    }
    .list{
        padding-left: 16px;
    }
    .tab-tag{
      height:0;
      padding: 0;
      line-height: 0;
      background: transparent;
    }
    .dsn{
        display: none;
    }
.el-form-item__label{
      text-align: left;
    }
    .imgPad{
      margin-left: 10px;
      margin-bottom: 10px;
      // margin-left: 2%;
    }
    .submit{
      margin-left: 10px;
    }
    .check{
      margin-left: 2%;
    }
    .red label{
      color: red;
    }
    .right{
      float: right;
    }

     .pic_label_text{
     color: #606266;
     text-align: center;
     align-self: center;
    }
    .branch-input{
     width:255px
    }
</style>
